var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',{attrs:{"errorMessage":_vm.errorMessage,"successMessage":_vm.successMessage,"showSearch":true,"topActionButtonSecondary":{
    text: 'Actions',
    key: 'actions',
    subItems: [
      _vm.viewingRecycleBin
        ? { title: 'Back to Companies', command: 'companies' }
        : { title: 'Recycle Bin', command: 'companies-recycle-bin' },
      { title: 'All Activities', command: 'companies-activities' }
    ]
  },"topActionButtonPrimary":_vm.viewingRecycleBin
      ? {}
      : { text: 'Create New Company', key: 'createNewCompany' }},on:{"toolbarSelectItem":_vm.onToolbarItemClick,"errorMessageClosed":function($event){_vm.errorMessage = ''}}},[_c('ListView',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading || _vm.loadingText),expression:"loading || loadingText"}],attrs:{"hideAllFilters":false,"tableRowActions":_vm.tableRowActions,"element-loading-text":_vm.loadingText,"data":_vm.companies,"tableActions":_vm.tableActions,"addAdvancedFilter":false,"tableColumns":_vm.tableColumns,"hideToggleIcons":true,"totalRecords":_vm.getTotalRecords,"paginationLinks":_vm.getCompaniesLinks,"showSelectable":true,"bulkMenuActions":_vm.bulkMenuActions},on:{"fetch-query":_vm.fetchPageData,"tableRowClicked":_vm.viewCallback,"table-row-action":_vm.handleResponseAction,"bulk-action-event":_vm.bulkActionHandler,"table-action":_vm.tableActionHandler,"selection-change":function($event){_vm.selectedDocuments = $event}}},[_c('NoResultsFound',{attrs:{"slot":"notFound","message":_vm.viewingRecycleBin ? 'Recycle Bin is empty.' : 'No Companies Found.'},slot:"notFound"})],1),_c('ModalMessage',{attrs:{"name":"companiesDeleteModal","icon":['fal', 'exclamation-circle'],"iconClass":"text-red-600 text-6xl","title":"Company Deletion","description":"This will delete the company. Continue?","showClose":true,"buttons":[
      {
        text: `Okay`,
        classList: ['bg-gray-100 text-gray-600 border-gray-300'],
        click: () => _vm.deleteOneCompany()
      },
      {
        text: `Cancel`,
        classList: ['bg-red-700'],
        click: () => _vm.$modal.hide('companiesDeleteModal')
      }
    ]}}),_c('ModalMessage',{attrs:{"name":"companiesBulkDeleteModal","icon":['fal', 'exclamation-circle'],"iconClass":"text-red-600 text-6xl","title":"Company(s) Deletion","description":"This will delete the selected companies. Continue?","showClose":true,"buttons":[
      {
        text: `Okay`,
        classList: ['bg-gray-100 text-gray-600 border-gray-300'],
        click: () => _vm.doDeleteBulkCompanies()
      },
      {
        text: `Cancel`,
        classList: ['bg-red-700'],
        click: () => _vm.$modal.hide('companiesBulkDeleteModal')
      }
    ]}}),_c('ModalMessage',{attrs:{"name":"companiesBulkRestoreModal","icon":['fal', 'exclamation-circle'],"iconClass":"text-blue-600 text-6xl","title":"Company(s) Restoration","description":"This will restore the selected companies. Continue?","showClose":true,"buttons":[
      {
        text: `Okay`,
        classList: ['bg-gray-100 text-gray-600 border-gray-300'],
        click: () => _vm.doRestoreBulkCompanies()
      },
      {
        text: `Cancel`,
        classList: ['bg-red-700'],
        click: () => _vm.$modal.hide('companiesBulkRestoreModal')
      }
    ]}}),_c('ModalBase',{attrs:{"name":"exportCompaniesModal","size":"medium","title":"Export Companies","position":"center","clickToClose":false,"showClose":true}},[_c('Exporter',{attrs:{"defaultType":"companies"},on:{"exported":function($event){return _vm.$modal.hide('exportCompaniesModal')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }